import type { Tag } from './types';

export default [
	{
		id: '1',
		name: 'Without Tag',
		color_id: '1',
	},
	{
		id: '2',
		name: 'Red',
		color_id: '2',
	},
	{
		id: '3',
		name: 'Orange',
		color_id: '3',
	},
	{
		id: '4',
		name: 'Yellow',
		color_id: '4',
	},
	{
		id: '5',
		name: 'Blue',
		color_id: '5',
	},
	{
		id: '6',
		name: 'Purple',
		color_id: '6',
	},
	{
		id: '7',
		name: 'Green',
		color_id: '7',
	},
	{
		id: '8',
		name: 'Magenta',
		color_id: '8',
	},
	{
		id: '9',
		name: 'Dark blue',
		color_id: '9',
	},
	{
		id: '10',
		name: 'Turquoise',
		color_id: '10',
	},
] as Tag[];
